/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const SignatureIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="signature-icon">
      <path d="M18.328,5.671 C16.766,4.11 14.232,4.11 12.671,5.671 C11.508,6.834 10.031,11.865 9.5,14 L10,14.5 C12.135,13.969 17.165,12.491 18.328,11.328 C19.891,9.767 19.891,7.234 18.328,5.671 Z" />
      <circle cx="15.5" cy="8.5" r="1" />
      <path d="M14.796,9.204 L9.75,14.25" />
      <polygon points="19.5 0.5 23.5 4.5 21 6 18 3" />
      <path d="M17.5,5 L18.5,3.5" />
      <path d="M20.5,5.5 L19,6.5" />
      <path d="M8,15.5 L4.5,15.5 C4.5,15.5 2.5,15.5 2.5,17.5 C2.5,19.5 4.5,19.5 4.5,19.5 L16.5,19.5 C16.5,19.5 18.5,19.5 18.5,21.5 C18.5,23.5 16.5,23.5 16.5,23.5 L0.5,23.5" />
    </g>
  </svg>
);

export default SignatureIcon;
